// src/components/MapComponent.js

import React from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import PropTypes from 'prop-types';

import L from 'leaflet';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

function LocationPicker({ onLocationChange, locations }) {
    useMapEvents({
        click(e) {
            if (locations.length < 3) {
                onLocationChange(e.latlng);
            }
        },
    });
    return null;
}

const defaultIcon = L.icon({
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28],
    shadowSize: [41, 41]
});

L.Marker.prototype.options.icon = defaultIcon;

const MapComponent = ({ center, locations, onLocationChange }) => {
    return (
        <MapContainer
            center={center}
            zoom={13}
            style={{ height: '300px', width: '100%' }}
        >
            <TileLayer
                url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                attribution=''
            />
            {locations.map((location, index) => (
                <Marker key={index} position={[location.latitude, location.longitude]} />
            ))}
            <LocationPicker onLocationChange={onLocationChange} locations={locations} />
        </MapContainer>
    );
};

MapComponent.propTypes = {
    center: PropTypes.arrayOf(PropTypes.number).isRequired,
    locations: PropTypes.arrayOf(
        PropTypes.shape({
            latitude: PropTypes.number.isRequired,
            longitude: PropTypes.number.isRequired,
        })
    ).isRequired,
    onLocationChange: PropTypes.func.isRequired,
};

export default MapComponent;
